import React from "react"
import { Form } from "react-bootstrap"
import { localize } from "services/base"
import { lang_json } from "signals/base"

const FormRender = (props) => {
	const t = (key) => localize(key)
	const { type, name, value, required, disabled, feedback, onChange, maxLength, invalid, customClass } = props

	const renderFeedback = () =>{
        return (
            <Form.Control.Feedback type="invalid">
                {lang_json.value[`error_${name}`]
                    ? t(`error_${name}`)
                    : t(`${name}`) + " " + t("error_not_valid")}
            </Form.Control.Feedback>
        )
    }

	return (
		<Form.Group className="mb-3" controlId={name}>
			<Form.Label className={`fw-bold ${name === "phone_number" ? `hide` : ``}`}>
				{t(`${name}`)}
				{required && <span className="text-danger"> *</span>}
			</Form.Label>
			<Form.Control
				as={type === "textarea" ? `textarea` : `input`}
				type={type === "number" ? `text`: type}
				// style={{ height: '80px' }}
				required={required}
				className={customClass}
				value={(value) ? decodeURIComponent(value) : ``}
				onChange={onChange}
				placeholder={t(`placeholder_${name}`)}
				disabled={disabled}
				maxLength={maxLength}
				isInvalid={invalid}
			/>
			{(feedback) && renderFeedback()}
		</Form.Group>
	)
}

export default FormRender
